(function(_){
    'use strict';

    _['TRIPADVISOR.NO-CONTENT']= 'Este módulo no tiene contenido.';

}(translations['es']));



// WEBPACK FOOTER //
// ./src/app/modules/tripadvisor/lang/tripadvisor-lang_es.js